import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { loadNotifications, searchNotifications, addNotification } from 'store/actions';

const initialState = {
    notifications: [],
    searchNotifications: [],
    error: null,
    loading: false
};

const loadNotificationsStart = (state, action) => {
    return updateObject( state, { error: null, loading: true } );
}

const loadNotificationsSuccess = (state, action) => {
    const notifications = [];
    let index = 0;
    // process notifications object
    for(let key in action.notifications) {
        // add notification to buffer
        notifications[index] = action.notifications[key];
        // set element type in notifications
        notifications[index]['elementType'] = 'notification';
        // increment index
        index++;
    }
    
    return updateObject( state, {
        notifications: notifications,
        loading: false
    });
}

const loadNotificationsFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}

const searchNotificationsStart = (state, action) => {
    return updateObject( state, { error: null, loading: true } );
}

const searchNotificationsSuccess = (state, action) => {
    // convert notification object to indexed array
    const notifications = [];
    let index = 0;
    // process notifications object
    for(let key in action.searchNotifications) {
        // add notification to buffer
        notifications[index] = action.searchNotifications[key];
        // set element type in notifications
        notifications[index]['elementType'] = 'notification';
        // increment index
        index++;
    }
    return updateObject( state, {
        searchNotifications: notifications,
        loading: false
    });
}

const searchNotificationsFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}

const addNotificationStart = (state, action) => {
    console.log('addNotificationStart');
    console.log(state);
    console.log(action);
    return updateObject( state, { error: null, loading: true } );
}

const addNotificationSuccess = (state, action) => {
    console.log('addNotificationSuccess');
    console.log(state);
    console.log(action);
    return updateObject( state, { error: null, loading: false } );
}

const addNotificationFail = (state, action) => {
    console.log('addNotificationFail');
    console.log(state);
    console.log(action);
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}

const setNotificationStart = (state, action) => {
    console.log('setNotificationStart');
    console.log(state);
    console.log(action);
    return updateObject( state, { error: null, loading: true } );
}

const setNotificationSuccess = (state, action) => {
    console.log('setNotificationSuccess');
    console.log(state);
    console.log(action);
    return updateObject( state, { error: null, loading: false } );
}

const setNotificationFail = (state, action) => {
    console.log('setNotificationFail');
    console.log(state);
    console.log(action);
    return updateObject( state, {
        error: action.error,
        loading: false
    });
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.NOTIFICATION_LOAD_START: return loadNotificationsStart(state, action);
        case actionTypes.NOTIFICATION_LOAD_SUCCESS: return loadNotificationsSuccess(state, action);
        case actionTypes.NOTIFICATION_LOAD_FAIL: return loadNotificationsFail(state, action);

        case actionTypes.NOTIFICATION_SEARCH_START: return searchNotificationsStart(state, action);
        case actionTypes.NOTIFICATION_SEARCH_SUCCESS: return searchNotificationsSuccess(state, action);
        case actionTypes.NOTIFICATION_SEARCH_FAIL: return searchNotificationsFail(state, action);

        case actionTypes.NOTIFICATION_ADD_START: return addNotificationStart(state, action);
        case actionTypes.NOTIFICATION_ADD_SUCCESS: return addNotificationSuccess(state, action);
        case actionTypes.NOTIFICATION_ADD_FAIL: return addNotificationFail(state, action);

        case actionTypes.NOTIFICATION_SET_START: return setNotificationStart(state, action);
        case actionTypes.NOTIFICATION_SET_SUCCESS: return setNotificationSuccess(state, action);
        case actionTypes.NOTIFICATION_SET_FAIL: return setNotificationFail(state, action);
        
        default: 
            return state;
    }
}

export default reducer;
